import type { ClassificationNodeId } from '@/interfaces/Classification.interface';
import type { CoreApiPaginatedRequestParams, CoreApiPaginatedResponse } from '@/rosa';
import type { HttpErrorResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type {
    ConflictResolutionStrategy,
    DocumentManagementFile,
    DocumentManagementFileId
} from '../../interfaces/DocumentManagement.interface';
import type { UnitCode } from '../../interfaces/Unit.interface';

export abstract class DocumentManagementProvider {
    abstract notifyFileChange(classificationNodeId: ClassificationNodeId | null): void;
    abstract getFiles$(
        classificationNodeId: ClassificationNodeId,
        paginationParams: CoreApiPaginatedRequestParams,
        exactName?: string
    ): Observable<CoreApiPaginatedResponse<DocumentManagementFile>>;
    abstract getFileByName(classificationNodeId: ClassificationNodeId, exactName: string): Promise<DocumentManagementFile>;
    abstract requestFilesDeletion(
        isAllSelected: boolean,
        includedOrExcludedFileIds: DocumentManagementFileId[],
        selectionSize: number,
        classificationNodeId: ClassificationNodeId
    ): void;
    abstract requestFileRenaming(file: DocumentManagementFile): void;
    abstract importFiles(classificationNodeId: ClassificationNodeId, files: File[]): Promise<any>;
    abstract addFile$(
        classificationNodeId: ClassificationNodeId,
        file: File,
        conflictResolutionStrategy: ConflictResolutionStrategy
    ): Observable<unknown>;
    abstract isFileNameAlreadyUsedError(errorResponse: HttpErrorResponse): boolean;
    abstract formatFileSize(fileSize: number, sourceUnitCode: UnitCode): string;
    abstract downloadFile(file: DocumentManagementFile): void;
    abstract getFilesQuota$(): Observable<{ limitInKB: number; currentInKB: number; percent: number }>;
    abstract getFileChanged$(): Observable<void>;
    abstract getRemainingFilesQuotaInKB$(): Observable<number>;
}
